import React from 'react';

type Iprops = {
  title: string;
  style?: object;
}

const SPTitle:React.FC<Iprops> = (props) => {
  const { title, style } = props || {};
  return <div className='sp-title' style={{ marginBottom: 24, display: 'flex', alignItems: 'center', fontSize: 16, fontWeight: 600, ...(style || {}) }}> <span style={{ width: 3, height: 16, background:' #FF6400', marginRight: 8 }}></span> {title}</div>
}

export default React.memo(SPTitle);